const reasonsblock = (state = [], action) => {
    switch (action.type) {
      case 'BLOCK':
      return {
          type: "BLOCK",
          reasons: action.reasons
        }
      default:
        return state
    }
  }
  
  export default reasonsblock